import React from 'react';
import Bone from 'react/elements/skeleton/Bone';

// ChatHeaderBar's page header before its room has loaded: the same header, with
// bones for the name, the topic and the actions, which all depend on the room.
export default function ChatHeaderSkeleton() {
	return (
		<div className='chat-header chat-header--page' aria-busy='true'>
			<h1 className='chat-header__title'>
				<span className='chat-header__hash'>#</span>
				<Bone width={120} height={20} />
			</h1>
			<p className='chat-header__topic'><Bone width={260} height={12} /></p>
			<div className='chat-header__actions'>
				{[0, 1, 2, 3].map((index) => (
					<span key={index} className='chat-header-action'>
						<Bone width={16} height={16} />
						<Bone width={30} height={8} />
					</span>
				))}
			</div>
		</div>
	);
}
